import React, { useEffect, useState, useRef } from 'react';
import storage from 'utils/storage';
import { emailOTPLogin } from '../api/emailOTPLogin';
import { VerificationCodeInputField } from 'components/Form';
import { RefreshCcw } from 'lucide-react';
import { Button, Text } from 'components/Elements';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'lib/auth';

export const EmailOTPLoginForm = () => {
  const [verificationCode, setVerificationCode] = useState();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [success, setSuccess] = useState(false);
  const [sendingOTP, setSendingOTP] = useState(false);

  const navigate = useNavigate();

  const { login } = useAuth();

  const otpSentRef = useRef(false); // Prevent multiple calls

  const email = Cookies.get('email');

  useEffect(() => {
    if (otpSentRef.current) return; // If already sent, prevent re-execution
    otpSentRef.current = true;

    const sendEmailOTP = async () => {
      setSendingOTP(true);
      try {
        const result = await emailOTPLogin({ email: email });
      } catch (err) {
        setError('Failed to send OTP. Please try again.');
      } finally {
        setSendingOTP(false);
      }
    };

    sendEmailOTP();
  }, []);

  const handleVerify = async () => {
    setVerifying(true);
    setError('');

    const fcmToken = storage.getFCMToken();

    try {
      await login({
        email: email,
        code: verificationCode,
        fcmToken,
      });
      navigate('/onboarding/choose-country');
      // Cookies.set('temp_token', result.user.token);
      // Cookies.set('authentication_level_email', 'pass');
      // navigate('/auth/security/sms');
    } catch (err) {
      setError('Invalid verification code. Please try again.');
    } finally {
      setVerifying(false);
    }
  };

  const handleRetry = async () => {
    setSendingOTP(true);
    setVerificationCode(null);
    try {
      const result = await emailOTPLogin({ email: email });
      console.log(result);
    } catch (err) {
      setSendingOTP(false);
      console.error('Failed to send OTP:', err);
      setError('Failed to send OTP. Please try again.');
    } finally {
      setSendingOTP(false);
    }
  };

  return (
    <div>
      <div className="mt-4">
        <label className="block text-sm text-white/80 mb-4 ">
          Provide the 6-digit code that has been sent to your email, {email} to
          verify login
        </label>

        <div className="flex space-x-2 justify-start mb-4">
          <VerificationCodeInputField
            length={6}
            onChange={(code) => setVerificationCode(code)}
          />
        </div>
      </div>
      {error && (
        <>
          <p className="text-red-500 text-center mt-3">{error}</p>
          <button
            onClick={handleRetry}
            className="mx-auto text-white bg-white/10 rounded-3xl  p-1 px-2 flex flex-row items-center space-x-2"
          >
            <RefreshCcw size={12} />
            {setSendingOTP ? 'Sending code...' : <Text>Try again</Text>}
          </button>
        </>
      )}
      <div className="w-full my-8">
        <Button
          className="w-full"
          onClick={handleVerify}
          variant="darkGlass"
          disabled={verifying || verificationCode === 6}
        >
          {verifying ? 'Verifying...' : 'Verify'}
        </Button>
      </div>
    </div>
  );
};
